import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import api from "@/lib/api";

/** Blocking gate: sellers must accept the current Seller Terms + Code of Conduct (versioned)
 *  before using the seller dashboard. Mounted once for seller portals. */
export default function SellerLegalGate() {
  const [status, setStatus] = useState(null);
  const [busy, setBusy] = useState(false);
  const [checked, setChecked] = useState(false);

  useEffect(() => { api.get("/marketplace/seller/legal-status").then((r) => setStatus(r.data)).catch(() => setStatus({ accepted: true })); }, []);

  if (!status || status.accepted) return null;

  const accept = async () => {
    setBusy(true);
    try { await api.post("/marketplace/seller/accept-legal"); setStatus({ ...status, accepted: true }); }
    catch { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-900/60 p-4" data-testid="seller-legal-gate">
      <div className="w-full max-w-md rounded-2xl bg-white p-6 shadow-xl">
        <div className="flex items-center gap-2"><ShieldCheck className="h-6 w-6 text-blue-500" /><h2 className="text-lg font-bold text-slate-900">Accept Seller Policies</h2></div>
        <p className="mt-2 text-sm text-slate-600">Before you continue selling on Suffle Online, please review and accept our current seller policies (v{status.required_version}).</p>
        <ul className="mt-3 space-y-1 text-sm">
          {(status.docs || []).map((d) => (
            <li key={d.slug}><Link to={`/legal/${d.slug}`} target="_blank" rel="noreferrer noopener noreferrer" className="font-medium text-blue-600 hover:underline" data-testid={`gate-doc-${d.slug}`}>{d.title} →</Link></li>
          ))}
        </ul>
        <label className="mt-4 flex items-start gap-2 text-sm text-slate-700">
          <input type="checkbox" checked={checked} onChange={(e) => setChecked(e.target.checked)} data-testid="gate-agree" className="mt-0.5" />
          I have read and agree to the Seller Terms & Conditions and Seller Code of Conduct.
        </label>
        <button onClick={accept} disabled={!checked || busy} data-testid="gate-accept" className="mt-4 w-full rounded-full brand-gradient-bg px-5 py-2.5 text-sm font-semibold text-white disabled:opacity-50">{busy ? "Saving…" : "Accept & Continue"}</button>
      </div>
    </div>
  );
}
